import React from 'react'
import { Form, Select } from 'components/common'

type Props = {
  canOverlap: boolean
  setCanOverlap: React.Dispatch<React.SetStateAction<boolean>>
  isNew: boolean
}

export const DiscountAllowMultipleCard: React.FC<Props> = (props) => {
  const { canOverlap, setCanOverlap, isNew } = props

  const options = [
    { label: '許可しない', value: false },
    { label: '許可する', value: true },
  ]

  return (
    <Form.Item
      name="canOverlap"
      label="全体のディスカウントとの重複"
      required={isNew}
    >
      {isNew ? (
        <Select options={options} onChange={setCanOverlap} />
      ) : (
        <p className="font-semibold">
          {canOverlap ? '許可する' : '許可しない'}
        </p>
      )}
    </Form.Item>
  )
}
